import { baseObjectSchema } from '../baseSchemas';
import { z } from 'zod';

export const range = baseObjectSchema.extend({
  name: z.string(),
  code: z.string(),
  isActive: z.boolean().optional(),
});

export const getRangesSchema = z.array(range);

export type GetRangesResponse = z.infer<typeof getRangesSchema>;
